import { initialStyles, Modal } from '@/components/modal/Modal'
import { ShareTwitterIcon } from '@/components/icon'
import { ShareFacebook } from '@/components/icon/ShareFacebook'
import { Srp } from '@/types'
import {
  FACEBOOK_HASH_TAG,
  FACEBOOK_SHARE_LINK,
  twitterTrim,
  TWITTER_HASH_TAG,
  TWITTER_SHARE_LINK,
} from '../../util'

interface Props {
  isOpen: boolean
  isSuccess: boolean
  srpStatus: Srp
  modalText: string
  comment: string
  summaryId: number
  onClose: () => void
  callback?: () => void
}
export const CompleteModal: React.FC<Props> = ({
  isOpen,
  isSuccess,
  srpStatus,
  modalText,
  comment,
  summaryId,
  onClose,
  callback,
}) => {
  const encodeComment = encodeURI(comment)
  const encodeTwitterComment = encodeURI(twitterTrim(comment))
  // twitterシェアの際に、シェア画像・シェアタイトル・シェア文章が出ない事象があったため、パラメータをつけて都度twitterのキャッシュを生成する
  const randomNumber = Math.floor(Math.random() * 100000000)
  const fbUrl = `${FACEBOOK_SHARE_LINK}${summaryId}&quote=${encodeComment}&hashtag=${FACEBOOK_HASH_TAG}`
  const twUrl = `${TWITTER_SHARE_LINK}${summaryId}?${randomNumber}&text=${encodeTwitterComment}&hashtags=${TWITTER_HASH_TAG}`

  const modalStyle = {
    ...initialStyles,
    content: {
      ...initialStyles.content,
      textAlign: 'center',
      width: '600px',
    },
  }

  const onTwitterClick = (e) => {
    e.stopPropagation()
    window.open(
      twUrl,
      'TWwindow',
      'width=600, height=406, menubar=no, toolbar=no, scrollbars=yes'
    )
    return false
  }
  const onFacebookClick = (e) => {
    e.stopPropagation()
    window.open(
      fbUrl,
      'FBwindow',
      'width=600, height=406, menubar=no, toolbar=no, scrollbars=yes'
    )
    return false
  }
  const onClick = () => {
    if (callback) callback()
    onClose()
  }

  return (
    <Modal open={isOpen} onRequestClose={() => onClose()} style={modalStyle}>
      <div className="p-4">
        {/** 共通 */}
        <div className="text-[16px] text-white">
          <div className="relative mt-[30px] mb-5 min-h-[50px] font-medium text-center">
            <div className="text-2xl leading-6 text-black">
              <span className="mx-auto mt-[30px] mb-0 font-bold text-center shadow-none">
                {modalText}
              </span>
            </div>
          </div>
        </div>
        {/** SRP_OPENだけ */}
        {srpStatus === Srp.OPEN_SRP && isSuccess && (
          <div className="relative px-[15px] pt-0">
            <div className="text-center">
              <div className="mx-auto mt-0 mb-[30px] w-[268px] text-left text-[#5d5d5d]">
                <div>
                  保存した「学びメモ」はそのままSNSでシェアすることもできます。
                </div>
                <div className="py-[30px] px-0 mt-5 text-center bg-[#f5f4f4] rounded-md">
                  <a
                    className="inline-block mx-[25px] no-underline hover:cursor-pointer"
                    onClick={onTwitterClick}
                  >
                    <ShareTwitterIcon width={50} className="mx-auto" />
                    <span className="text-[#1da1f2] hover:text-[#23527c]">
                      twitter
                    </span>
                  </a>
                  <a
                    className="inline-block mx-[25px] no-underline hover:cursor-pointer"
                    onClick={onFacebookClick}
                  >
                    <ShareFacebook width={50} className="mx-auto" />
                    <span className="text-[#1877f2] hover:text-[#23527c]">
                      facebook
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}
        <button
          onClick={onClick}
          className="block py-1 px-[7px] mx-auto mt-0 mb-[30px] w-[160px] h-10 text-base text-center text-[#1d6dcc] bg-white rounded-[28px] border border-[#1d6dcc] border-solid outline-none"
        >
          閉じる
        </button>
      </div>
    </Modal>
  )
}
